// ── CallRegister 킵 해제·킵 메모 액션 (useCallRegisterSubmit.js 에서 글자 그대로 옮김, 2026-10-13) ──
// - openKeepReleaseModal: 킵 해제 모달 열기
// - onKeepMemoSave: 킵 메모만 저장
// - onKeepReleaseAssign: 킵 해제 + 다시 방문 배정
// - onKeepReleaseCancelVisit: 킵 해제 + 방문취소

import { apiClient } from '../../../api/apiClient';
import { makeEditForm } from './utils';

// callsUrl: 콜 쓰기 주소 — 기본 '/api/tm/calls', 통합 일일콜 메뉴는 메뉴 주소(2026-10-13)
export function createCallKeepActions(core, {
  showToast, fetchList, nextBizDate, callsUrl = '/api/tm/calls',
}, fetchLatestCall) {
  const {
    keepReleaseTarget, keepReleaseDate, keepReleaseSales,
    keepReleaseMemo, setKeepReleaseMemo,
    setKeepReleaseOpen, setKeepReleaseSaving,
  } = core;

  // ── 킵 해제 모달 열기 ─────────────────────────────────────────────────────
  async function openKeepReleaseModal(row) {
    const latest = await fetchLatestCall(row);
    if (!latest) return;
    core.setKeepReleaseTarget(latest);
    const nextDate = await nextBizDate();
    core.setKeepReleaseDate(nextDate);
    core.setKeepReleaseSales(String(latest?.sales_person_name || '').trim());
    setKeepReleaseMemo(String(latest?.keep_memo || ''));
    // 창 버튼 가능 여부(2026-11-02) — 저장 주소가 '/api/tm/calls' 일 때만 묻는다(통합 메뉴는 저장 길이 달라 지금처럼 전부 켬)
    let actions = null;
    if (callsUrl === '/api/tm/calls') {
      const a = await apiClient.get(`${callsUrl}/${Number(latest.id)}/keep-actions`);
      // 못 물어보면(거절·오류) 전부 막는다 — 저장도 같은 주소라 어차피 안 된다(권한값 없으면 숨김)
      actions = a.ok && a.data?.actions ? a.data.actions : { memo: false, close: false, reassign: false };
    }
    core.setKeepReleaseActions(actions);
    core.setKeepReleaseOpen(true);
  }

  // ── 킵 메모만 저장 ─────────────────────────────────────────────
  async function onKeepMemoSave() {
    if (!keepReleaseTarget?.id) return;
    const callId = Number(keepReleaseTarget.id);
    setKeepReleaseSaving(true);
    const r = await apiClient.put(`${callsUrl}/${callId}`, {
      keep_memo: keepReleaseMemo || '',
    });
    setKeepReleaseSaving(false);
    if (!r.ok) { showToast('킵 메모 저장에 실패했습니다.', 'error'); return; }
    showToast('킵 메모를 저장했습니다.', 'success');
    fetchList();
  }

  // ── 킵 해제 + 다시 방문 배정 ──────────────────────────────────────────────
  async function onKeepReleaseAssign() {
    if (!keepReleaseTarget?.id) return;
    const callId = Number(keepReleaseTarget.id);
    if (!keepReleaseDate.trim()) { showToast('방문일자를 입력해 주세요.', 'error'); return; }
    const salesName = keepReleaseSales.trim() || String(keepReleaseTarget.sales_person_name || '').trim();
    setKeepReleaseSaving(true);
    const baseForm = makeEditForm(keepReleaseTarget);
    const r = await apiClient.put(`${callsUrl}/${callId}`, {
      ...baseForm,
      visit_date: keepReleaseDate,
      sales_person_name: salesName,
      // 킵 해제 시 feedback(미뤄짐) 초기화
      feedback: '',
      feedback_memo: baseForm.feedback_memo || '',
      keep_memo: keepReleaseMemo || '',
      is_keep: false,
    });
    setKeepReleaseSaving(false);
    if (!r.ok) { showToast('방문 배정에 실패했습니다.', 'error'); return; }
    showToast('방문이 재배정되었습니다.', 'success');
    setKeepReleaseOpen(false);
    fetchList();
  }

  // ── 킵 해제 + 방문취소 처리 ───────────────────────────────────────────────
  async function onKeepReleaseCancelVisit() {
    if (!keepReleaseTarget?.id) return;
    const callId = Number(keepReleaseTarget.id);
    setKeepReleaseSaving(true);
    const r = await apiClient.put(`${callsUrl}/${callId}`, {
      feedback: '방문취소',
      keep_memo: keepReleaseMemo || '',
      is_keep: false,
    });
    setKeepReleaseSaving(false);
    if (!r.ok) { showToast('처리에 실패했습니다.', 'error'); return; }
    showToast('미팅 종료로 처리되었습니다.', 'success');
    setKeepReleaseOpen(false);
    fetchList();
  }

  return { openKeepReleaseModal, onKeepMemoSave, onKeepReleaseAssign, onKeepReleaseCancelVisit };
}
